export const TRANSLATION_BUFFER_MS = 0;
